import React, { useState } from 'react';

const DebtSyndicationServices = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Debt Syndication.',
    website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with Debt Syndication.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Debt Syndication Services
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Comprehensive debt syndication solutions to help businesses secure optimal financing from multiple lenders. Our expertise in structuring, negotiating, and closing debt transactions ensures you get the best terms for your capital requirements.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">💰</span> Secure Optimal Financing
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Our Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">What We Need</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Debt Syndication Services
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Debt syndication involves arranging financing from a group of lenders for a single borrower. Our debt syndication services help businesses secure large-scale financing that might be beyond the capacity of a single lender, ensuring optimal terms and efficient capital raising.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                We specialize in structuring debt facilities, identifying suitable lenders, negotiating favorable terms, and managing the entire syndication process from start to finish. Our extensive network of financial institutions and deep understanding of credit markets enable us to secure the best possible financing solutions for your business.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Whether you need project financing, working capital facilities, acquisition financing, or corporate debt restructuring, our debt syndication expertise ensures successful capital raising with competitive interest rates and flexible repayment structures.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Optimal Financing Structure:</strong> Tailored debt solutions with competitive interest rates and flexible repayment terms.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Extensive Lender Network:</strong> Access to diverse lending institutions including banks, NBFCs, and financial institutions.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Expert Negotiation:</strong> Skilled negotiation to secure favorable terms, covenants, and conditions.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Risk Mitigation:</strong> Diversified lender base reduces dependency on single financing sources.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Efficient Process Management:</strong> End-to-end management of documentation, due diligence, and closing.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Regulatory Compliance:</strong> Ensuring all transactions comply with relevant financial regulations and guidelines.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Post-Syndication Support:</strong> Ongoing relationship management with lending consortium and compliance monitoring.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Debt Syndication." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Debt Syndication
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "🔍", title: "Needs Assessment", desc: "Comprehensive analysis of financing requirements, business objectives, and debt capacity assessment." },
              { number: "02", icon: "📝", title: "Documentation Preparation", desc: "Preparation of information memorandum, financial models, and business presentation for lenders." },
              { number: "03", icon: "👥", title: "Lender Identification", desc: "Identification and approach to suitable lenders based on transaction size, industry, and risk appetite." },
              { number: "04", icon: "📊", title: "Lender Presentations", desc: "Coordinating management presentations and due diligence sessions with potential lending institutions." },
              { number: "05", icon: "📋", title: "Term Sheet Evaluation", desc: "Analysis and comparison of term sheets received from various lenders to select optimal offers." },
              { number: "06", icon: "🤝", title: "Negotiation & Finalization", desc: "Negotiating final terms, conditions, covenants, and documentation with selected lending consortium." },
              { number: "07", icon: "✅", title: "Documentation & Closing", desc: "Finalizing legal documentation, security creation, and financial closure of the syndicated facility." },
              { number: "08", icon: "📈", title: "Post-Closure Support", desc: "Ongoing support for compliance monitoring, lender relationships, and future financing needs." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Information We Need
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Essential Documentation
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "📄", title: "Financial Statements", desc: "Audited financial statements for last 3-5 years, including balance sheets, P&L statements, and cash flow statements." },
              { icon: "💰", title: "Business Plan", desc: "Detailed business plan with growth projections, use of funds, and repayment capacity analysis." },
              { icon: "📊", title: "Financial Projections", desc: "Detailed financial projections for next 3-5 years including revenue, expenses, and cash flow forecasts." },
              { icon: "🏢", title: "Corporate Documents", desc: "Company incorporation documents, board resolutions, and corporate structure details." },
              { icon: "🛡️", title: "Collateral Details", desc: "Information about assets available as collateral, valuations, and existing charges." },
              { icon: "📜", title: "Credit History", desc: "Existing loan details, repayment track record, and credit rating reports if available." },
              { icon: "🎯", title: "Funding Requirements", desc: "Detailed breakdown of funding requirements, purpose of funds, and implementation timeline." },
              { icon: "👥", title: "Management Profiles", desc: "Background and experience of key management personnel and promoters." },
              { icon: "📈", title: "Industry Analysis", desc: "Market position, competitive landscape, and industry growth prospects." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "📄", title: "Structured Financing Proposal", desc: "Comprehensive debt structuring proposal with optimal terms, conditions, and repayment schedule." },
              { icon: "👥", title: "Lender Consortium", desc: "Access to pre-qualified lending institutions matched to your business profile and requirements." },
              { icon: "🤝", title: "Negotiated Terms", desc: "Favorable interest rates, flexible repayment structures, and reasonable covenants negotiated on your behalf." },
              { icon: "✅", title: "Complete Documentation", desc: "All legal documentation, loan agreements, security creation, and regulatory compliance completed." },
              { icon: "🎧", title: "Ongoing Support", desc: "Lender relationship management, compliance monitoring, future financing advisory, restructuring support if needed" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      Debt Syndication FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "What is debt syndication and when is it beneficial?", 
                    answer: "Debt syndication involves arranging financing from multiple lenders for a single borrower. It's beneficial when financing requirements exceed a single lender's exposure limits, when seeking competitive terms through multiple offers, or when diversifying funding sources to reduce dependency risk." 
                  },
                  { 
                    question: "How long does the debt syndication process typically take?", 
                    answer: "The timeline varies based on transaction complexity, but typically ranges from 4-12 weeks. Simple working capital facilities may close in 4-6 weeks, while large project financing or acquisition deals may take 8-12 weeks from mandate to financial closure." 
                  },
                  { 
                    question: "What types of debt facilities can be syndicated?", 
                    answer: "We syndicate various debt instruments including term loans, working capital facilities, project financing, acquisition financing, bridge loans, mezzanine debt, and corporate debt restructuring. The structure depends on your specific requirements and lender appetite." 
                  },
                  { 
                    question: "What are the typical costs involved in debt syndication?", 
                    answer: "Costs typically include arrangement fees (0.5-2% of facility size), legal fees, due diligence costs, and potentially commitment fees. We provide transparent cost estimates upfront and often structure fees to be payable only upon successful closure." 
                  },
                  { 
                    question: "Can startups or smaller businesses avail debt syndication services?", 
                    answer: "Yes, while traditionally used by larger corporations, we also facilitate syndication for growing businesses and startups with strong fundamentals. Minimum transaction sizes typically start around ₹5-10 crores, depending on the business profile and industry." 
                  },
                  { 
                    question: "How do you ensure we get the best terms in syndicated deals?", 
                    answer: "We leverage competitive tension among multiple lenders, our deep understanding of credit markets, and strong negotiation skills. Our extensive lender relationships and market intelligence ensure you receive competitive pricing and favorable terms tailored to your needs." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready to Secure Optimal Financing?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our debt syndication experts help you structure and secure the best financing solution for your business growth and capital requirements.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">💰</span> Discuss Your Financing Needs
            </a>
        </div>
      </section>
    </main>
  );
};

export default DebtSyndicationServices;